import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { PageHeader } from "@/components/common/page-header"
import { ComplianceGapSummary } from "@/features/compliance/components/compliance-gap-summary"
import { ComplianceLacking } from "@/features/compliance/components/compliance-lacking"
import { complianceQueries } from "@/queries/compliance"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/compliance/$gapKey/"
)({
  validateSearch: z.object({ q: z.string().optional() }),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(complianceQueries.gap(params.gapKey)),
  component: ComplianceGapPage,
})

function ComplianceGapPage() {
  const { gapKey } = Route.useParams()
  const { data } = useSuspenseQuery(complianceQueries.gap(gapKey))
  const { q } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader
        title={data.label}
        back={{ label: "Compliance", to: "/$organisation/compliance" }}
      />
      <div className="flex flex-col gap-10">
        <ComplianceGapSummary gapKey={gapKey} />
        <ComplianceLacking
          gapKey={gapKey}
          search={q}
          onSearch={(search) =>
            void navigate({ replace: true, search: { q: search } })
          }
        />
      </div>
    </>
  )
}
